import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Priya Sharma",
    college: "Delhi University",
    avatar: "PS",
    rating: 5,
    text: "Submitted my entire history assignment in 10 minutes! My handwriting is terrible but NoteGenius understood everything perfectly.",
  },
  {
    name: "Rahul Verma",
    college: "IIT Bombay",
    avatar: "RV",
    rating: 5,
    text: "The flashcard generator is a game-changer. Created 50 flashcards from my physics notes in seconds. Scored 95% in my exam!",
  },
  {
    name: "Ananya Patel",
    college: "Christ University",
    avatar: "AP",
    rating: 5,
    text: "I was skeptical but the 3 free credits convinced me to try. Now I can't imagine studying without it. Worth every rupee!",
  },
  {
    name: "Vikash Kumar",
    college: "BITS Pilani",
    avatar: "VK",
    rating: 5,
    text: "PPT generator saved me hours of work. Just uploaded my notes and got a professional presentation in minutes.",
  },
  {
    name: "Sneha Reddy",
    college: "Anna University",
    avatar: "SR",
    rating: 5,
    text: "Best study tool for Indian students. Affordable pricing and the AI actually understands our handwriting!",
  },
  {
    name: "Arjun Nair",
    college: "VIT Vellore",
    avatar: "AN",
    rating: 5,
    text: "Used it for my semester exams. The quiz generator helped me identify gaps in my preparation. Highly recommend!",
  },
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mt-2 mb-4">
            Loved by 50,000+ Students
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Join thousands of students who are already studying smarter with NoteGenius.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.name}
              className="relative gradient-card rounded-2xl p-6 shadow-card hover:shadow-glow transition-all duration-300 hover:scale-[1.02] border border-border/50"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Quote icon */}
              <Quote className="absolute top-4 right-4 w-8 h-8 text-primary/20" />

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>

              {/* Text */}
              <p className="text-foreground/90 text-sm leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center text-primary-foreground font-semibold text-sm">
                  {testimonial.avatar}
                </div>
                <div>
                  <div className="font-semibold text-foreground text-sm">
                    {testimonial.name}
                  </div>
                  <div className="text-muted-foreground text-xs">
                    {testimonial.college}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust stats */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-green-500/10 border border-green-500/20">
            <span className="text-2xl">⭐</span>
            <span className="text-foreground font-semibold">
              4.9/5 rating from 2,000+ reviews
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
